export enum DeviceType {
  None = 0,
  iOS = 1,
  Android = 2,
  Web = 3,
}
